module.exports = __webpack_public_path__ + "img/intex-banner.19a4b092.jpg";